// extracted by mini-css-extract-plugin
module.exports = {"addSectionButton":"CreateSection_addSectionButton__22BnG","text":"CreateSection_text__l8V1C","withBorderBottom":"CreateSection_withBorderBottom__1DBUY"};